const setCookie = (key, value, expires) => {
  document.cookie = `${key}=${value}; expires=${expires}; Secure=true;`;
};

const readCookie = (key) => {
  const result = document.cookie.match("(^|[^;]+)\\s*" + key + "\\s*=\\s*([^;]+)")
  return result ? result.pop() : ""
};

const eraseCookie = (key) => document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;

export { setCookie, readCookie, eraseCookie };
